// eslint-disable-next-line no-shadow
export enum ScheduleDictionary {
  JOIN_THE_SESSION = 'Join the Session',
  JOIN_SESSION = 'Join Session',
  COPY_LINK = 'Copy Link',
  ALL_EVENTS = 'All Events',
  NEXT_SESSION = 'NEXT SESSION',
  LIVE = 'LIVE',
}
